import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import './index.scss'
import {Button, Modal, Input, message,Collapse, Tooltip} from "antd";

import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../../../servers/menuAPI";
import { getStorage} from "@/utils";
import {refreshMenu} from "../../../../../../redux/common/action";
import {selectPicDetail} from "../../../../../../servers/menu";
import {gotonext} from "../../../../../../utils";
import store from "../../../../../../redux";

const { Panel } = Collapse;
@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.lookscore = this.lookscore.bind(this)
    this.downloads = this.downloads.bind(this)
    this.handlePreview = this.handlePreview.bind(this)
    this.handleCancelstatus = this.handleCancelstatus.bind(this)
    this.modalCancel = this.modalCancel.bind(this)
  }


  state = {
    data: [],
    tips:'',
    isModalVisible:false,
    previewImage:'',
    detailstatus: false,
    detaildata:[],
  }

  showModal = () => {
    this.setState({
      isModalVisible:true
    })
  };

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  };

    onSubmit(data){
    gotonext()
    this.props.history.push({
      pathname: '/informationDeclaration/standardManage/organization/systemCentral',
    });
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'1.1.1',
      museumid: store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      this.setState({
        data:res.records,
        tips: res.extra?res.extra:''?res.extra:''
      })
    })
    const element = document.getElementById('top');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到元素位置
    }
  }


  computedData(data){
    const str = data.replaceAll('\n', '</br>')
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }

  createMarkup(str) {
    return {__html: str}
  }

  changeinput(e,index){
    e.persist()
    const d = this.state.data
    d.forEach((item,i)=>{
      if (index === i) {
        item.score = e.target.value
      }
    })
    this.setState({
      data:d
    })
  }

  async handlePreview(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].filepreviewurl !== '' && res.records[0].filepreviewurl !== null) {
        const type = res.records[0].filename.split('.')[res.records[0].filename.split('.').length - 1]
        clearTimeout(timer)
        window.open(res.records[0].filepreviewurl, '_blank')
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  downloads(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].fileurl !== '' && res.records[0].fileurl !== null) {
        clearTimeout(timer)
        window.location.href = res.records[0].fileurl
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  // modal取消
  modalCancel(){
    this.setState({
      previewVisible: false
    })
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

  componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  computedData(data){
    const str = data.replaceAll('\n', '</br>')
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }

  createMarkup(str) {
    return {__html: str}
  }

  changeinput(e,index){
    e.persist()
    const d = this.state.data
    d.forEach((item,i)=>{
      if (index === i) {
        item.score = e.target.value
      }
    })
    this.setState({
      data:d
    })
  }

  lookscore(data){
    data.forEach((item,index)=>{
      if (index!==0) {
        item[0] = index
      }
    })
    this.setState({
      detailstatus:true,
      detaildata:data,
    })
  }

  handleCancelstatus(){
    this.setState({
      detailstatus:false
    })
  }

  render(){
    return (
        <div className='detail-container' id="top">
          {this.state.tips.scoretips?
              <div className="import">
                <Collapse accordion>
                  <Panel header="考察要点" key="1">
                    <div style={{fontWeight:'bold',color:'red',fontSize:'18px'}}>
                      {this.state.tips!==''?this.computedData(decodeURIComponent(this.state.tips.scoretips)):''}
                    </div>
                  </Panel>
                </Collapse>
              </div>:''
          }
          {this.state.data.map((item,index)=>{
            return (
                <div className="detail-item">
                  <div className='detail-title'>
                    <span style={{display:"flex",alignItems:'center'}}>
                      <div style={{width:'90%'}}>{item.name}</div>
                      {item.formtips?
<Tooltip placement="left" title={this.computedData(decodeURIComponent(item.formtips))}>                            <span style={{color:'orange',marginLeft:'10px',cursor:'pointer',width:'85px',display:'block'}}>评分要点</span>
                          </Tooltip>:''
                      }
                    </span>
                    <div className='detail-score'>
                          <div style={{display:'flex',alignItems:'center'}}>
                            <div className='scoreintro'>{item.scorelabel}</div>
                            {
                              item.type === '1G10' ? '' :
                                  item.scoredetaillist && item.scoredetaillist.length > 0 ?
                                  <Button size="small" type="primary" onClick={()=>{this.lookscore(item.scoredetaillist)}} style={{marginTop:0,fontSize:'12px'}}>
                                    查看
                                  </Button>
                                  :''}
                              </div>
                    </div>
                  </div>
                  {item.annextypes?
                      <div className='detail-content' style={{margin:'10px 0'}}>
                        <span style={{fontWeight:'bold',marginRight:'15px'}}>附件类别名称:</span>{item.annextypes}
                      </div>:''
                  }<div className='detail-content'>
                     {this.computedData(decodeURIComponent(item.fillin))}
                  </div>
                  <ul className='uploadlistScore'>
                    {
                      item.annexlist.length>0?
                          item.annexlist.map((item1,index1)=>{
                            return <li>
                              <span>{index1+1}.{item1.filename}</span>
                              <div>
                                <span className="textbtn" onClick={()=>{this.downloads(item1)}}>下载</span>
                                <span className="textbtn" onClick={()=>{this.handlePreview(item1)}}>预览</span>
                              </div>
                            </li>
                          }):''
                    }
                  </ul>
                </div>
            )
          })}
          <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
            <Button type="primary" className='yl' onClick={this.onSubmit}>下一步</Button>
          </div>
          <Modal title="附件预览" visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel}>
            <div style={{width:'100%',minHeight:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
              <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
            </div>
          </Modal>
          <Modal title="评分详情"
                 visible={this.state.detailstatus}
                 onCancel={this.handleCancelstatus}
                 footer={[
                   <Button key="submit" type="primary" onClick={this.handleCancelstatus}>
                     取消
                   </Button>
                 ]}
          >
            <div>
              {
                this.state.detaildata.map((item,index)=>{
                  if (index === 0) {
                    return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                      {
                        item.map(item2=>{
                          return (
                              <div style={{width:'100px',textAlign:'center'}}>{item2}</div>
                          )
                        })
                      }
                    </div>)
                  } else {
                    return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                      {
                        item.map((item3)=>{
                            return (<div style={{width:'100px',textAlign:'center',marginTop:'10px'}}>{item3}</div>)
                        })
                      }
                    </div>)
                  }
                })
              }
            </div>
          </Modal>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
